
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/portabilidade-de-dividas",
      function () {
        return require("private-next-pages/portabilidade-de-dividas.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/portabilidade-de-dividas"])
      });
    }
  